module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/completed-e7953232538d21a3081ac0b41efdb558.png";